import React from 'react'
import { Head } from '@inertiajs/react'
import classNames from 'classnames/bind'
import AdminLayout from '@/admin/shell/layouts/AdminLayout'
import styles from '../Settings.module.scss'

const cx = classNames.bind(styles)

function SettingsPage() {
  return (
    <>
      <Head title="Admin — Settings" />
      <div className={cx('page')}>
        <h1 className={cx('heading')}>Settings</h1>
        <p className={cx('subheading')}>Application configuration.</p>
        <div className={cx('placeholder')}>
          <p>Settings panel coming soon.</p>
        </div>
      </div>
    </>
  )
}

SettingsPage.layout = (page: React.ReactNode) => (
  <AdminLayout title="Settings">{page}</AdminLayout>
)

export default SettingsPage
